export default "__VITE_ASSET__CKzv4urt__"